import { render, staticRenderFns } from "./GroupBuyingStatistics.vue?vue&type=template&id=09563211&scoped=true&"
import script from "./GroupBuyingStatistics.vue?vue&type=script&lang=js&"
export * from "./GroupBuyingStatistics.vue?vue&type=script&lang=js&"
import style0 from "./GroupBuyingStatistics.vue?vue&type=style&index=0&id=09563211&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09563211",
  null
  
)

export default component.exports